import { render, staticRenderFns } from "./MensagensLogs.vue?vue&type=template&id=0eff8d52&"
import script from "./MensagensLogs.vue?vue&type=script&lang=js&"
export * from "./MensagensLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports